module.exports = __webpack_public_path__ + "static/img/banner-m.bd73487.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner-m.jpg
// module id = gjbP
// module chunks = 1